<template>
  <v-col cols="12" class="login"
    :style="`background: linear-gradient(to bottom, ${$env.VUE_APP_ACCENT_COLOR} 0%, #FFFFFF 100%) !important;`">
    <v-col cols="12" class="text-left">
      <h1 class="display-2 white--text text-center">{{ $wm.title }}</h1>
    </v-col>

    <v-col cols="12" md="6" class="mx-auto mt-16">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6" v-if="!$vuetify.breakpoint.mobile">
              <h1>{{ $wm.title }}</h1>

              <div v-html="$wm.description"></div>

              <v-btn color="primary" rounded class="font-weight-bold" elevation="0" :href="$wm.pricing_link">En savoir
                plus</v-btn>
            </v-col>
            <v-col cols="12" :md="iOS ? 12 : 6">
              <h1 class="mb-6">
                {{
                    loginForm
                      ? $t("login.connection.title")
                      : $t("login.register.title")
                }}
              </h1>
              <v-alert colored-border border="top" color="error" v-model="notValidUser">
                Veuillez cliquer sur le lien de confirmation que vous avez reçu
                dans votre boite mail, si ce n'est pas le cas regardez dans
                votre boite de spam ou contactez-nous par mail sur la boite :
                support@previmeteo.com
              </v-alert>
              <template v-if="loginForm">
                <transition name="fade">
                  <v-form @submit.prevent="login" ref="formLogin" lazy-validation>
                    <v-text-field :label="$t('login.connection.email')" filled rounded dense type="email" name="email"
                      v-model="user.user_email" />
                    <v-text-field :label="$t('login.connection.password')" filled rounded dense type="password"
                      name="password" v-model="user.user_password" />
                    <a @click="openLostPassword = true">{{ $t('lost_pass') }}</a>
                    <v-btn elevation="0" block rounded color="primary" type="submit" class="my-3"
                      :loading="loginLoading">{{ $t("login.connection.title") }}</v-btn>

                    <hr class="my-6" />
                    <v-btn elevation="0" block rounded color="info" type="button" to="/register">{{
                        $t("login.register.title")
                    }}</v-btn>
                  </v-form>
                </transition>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-dialog width="80vw" v-model="openLostPassword">
        <v-card>
          <v-card-text>
            <v-col>
              <v-alert colored-border border="top" color="success" v-model="succesLostPassword">
                Un email de changement de mot de passe vient de vous être
                envoyé.
              </v-alert>
              <v-alert colored-border border="top" color="error" v-model="errorLostPassword">
                Une erreur s'est produite veuillez réessayer plus tard
              </v-alert>
              <v-form @submit.prevent="sendLostPassword()">
                <v-text-field filled rounded placeholder="Email rataché à votre compte" dense
                  v-model="lost_password_email" />
                <v-btn @click="sendLostPassword()" block rounded color="primary">Changer de mot de passe</v-btn>
              </v-form>
            </v-col>
          </v-card-text>
        </v-card>

      </v-dialog>


      <v-col class="px-0">
        <v-select label="Langue" @change="changeLang" v-model="lang" dense filled rounded
          :items="[{ text: '🇫🇷 Français', value: 'fr' }, { text: '🇬🇧 English', value: 'en' }]" />
      </v-col>
    </v-col>

    <v-col cols="12" md="6" class="mx-auto text-center" v-if="getPlatform == 'web' && $env.VUE_APP_ORG_NAME == 'pm'">
      <h2 class="mb-6 white--text">{{ $t('our_apps') }}</h2>
      <v-btn outlined class="mx-3" :class="$vuetify.breakpoint.mobile ? 'mb-3' : ''"
        href="https://play.google.com/store/apps/details?id=com.previmeteo.alerts&amp;hl=fr" color="white">
        <v-icon>mdi-google-play</v-icon> Play Store
      </v-btn>
      <v-btn class="mx-3" href="https://apps.apple.com/fr/app/my-previmeteo/id1050964320" outlined color="white">
        <v-icon>mdi-apple</v-icon> App Store
      </v-btn>
    </v-col>

    <v-snackbar top block v-model="success" color="success">{{
        $t("login.snackbarSuccess")
    }}</v-snackbar>
    <v-snackbar top block v-model="successConfirmEmail" color="success">Email validé avec succés</v-snackbar>
    <v-snackbar top block v-model="error" color="error">{{
        $t("login.snackbarError")
    }}</v-snackbar>
  </v-col>
</template>

<script>
import api from "@/api";
import { Capacitor } from '@capacitor/core';
export default {
  data: () => ({
    // Form data
    openLostPassword: false,
    succesLostPassword: false,
    errorLostPassword: false,
    lost_password_email: null,
    user: {
      user_nom: null,
      user_prenom: null,
      user_email: null,
      user_password: null,
    },
    phoneValid: null,
    // Form settings
    loginForm: true,
    // Error snackbar
    success: false,
    error: false,
    successConfirmEmail: false,
    loading: false,
    loginLoading: false,
    registerLoading: false,
    notValidUser: false,
    lang: "fr",
  }),
  computed: {
    getPlatform() {
      return Capacitor.getPlatform();
    },
    iOS() {

      return Capacitor.getPlatform() == 'ios' ? true : false;
    },
  },
  methods: {
    changeLang() {
      this.$i18n.locale = this.lang
      localStorage.setItem("lang", this.lang);
    },
    async sendLostPassword() {
      try {
        await api.users.lostPassword(this.lost_password_email);
        this.succesLostPassword = true;
        localStorage.clear();
      } catch (err) {
        this.errorLostPassword = true;
        console.og(err);
      }
    },
    // Lazy validation on phone input
    phoneValidation(formattedNumber, { number, valid }) {
      this.user.user_phone = number.international;
      this.phoneValid = valid;
    },
    // Log in user
    async login() {
      this.loginLoading = true;
      this.loading = true;
      try {
        let login = await api.login(
          this.user.user_email,
          this.user.user_password
        );

        if (login.user.is_valid) {
          // Store token & user informations
          this.$store.dispatch("setToken", login.token);
          let user = await api.users.get(login.user.id_user);
          this.$store.dispatch("setUser", user);
          if (this.$route.query.free_test) {
            await api.registerFreeTest(login.user.id_user);
          }
          this.$router.push(`/${this.$route.query.redirect || ""}`);
        } else {
          this.notValidUser = true;
        }
      } catch (err) {
        console.error(err);
        this.error = true;
      }
      this.loading = false;
      this.loginLoading = false;
    },
    // register new user
    async register() {
      this.registerLoading = true;
      if (this.$refs.registerFormRef.validate()) {
        try {
          if (this.$route.query.referrer) {
            this.user.referrer = this.$route.query.referrer;
          }
          await api.registerUser(this.user);

          this.success = true;
          this.loginForm = !this.loginForm;
        } catch (err) {
          console.error(err);
          this.error = true;
        }
      }
      this.registerLoading = false;
    },
  },
  mounted() {
    this.lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "fr";
    if (this.$route.query.register) {
      this.loginForm = false;
    }
    if (this.$route.query.confirm_email) {
      api.confirm_email(this.$route.query.confirm_email).then((res) => {
        if (res.affectedRows) {
          this.successConfirmEmail = true;
        }
      });
    }
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.login {
  height: 100vh;

  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: scroll !important;
}
</style>